module.exports = __webpack_public_path__ + "assets/img/vegetable.1f9fefe7.png";